import { createStore, applyMiddleware, compose } from "redux";
import thunkMiddleware from "redux-thunk";
import myEntityThunk from "./entityThunk";
import { createLogger } from "redux-logger";
import { loadGridStates } from "../reducers/dataGrid";
import { getLocalLanguage } from '../reducers/language';
import rootReducer from '../reducers/index';
import { initialState as appInitialState } from '../reducers/app'
import { routerMiddleware } from 'react-router-redux';
import { createBrowserHistory, createMemoryHistory } from 'history';
import config from 'cityads-v3/config';


const loggerMiddleware = config.REDUX_LOGGER ? createLogger({
  collapsed: (getState, action, logEntry) => !logEntry.error,
  duration: true
}) : () => next => action => next(action);

let initialState = (window || {}).__INITIAL_STATE__ || {};

const composeEnhancers = (window || {}).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export default function configureStore(ops = {}) {
  let store;
  let history;

  if ((ops.isBrowser && Object.keys(initialState).length) || ops.initialState) {
    let dataGridByName = {};

    if (typeof localStorage !== 'undefined') {
      dataGridByName = loadGridStates();
    }

    history = createBrowserHistory();

    const user = initialState?.auth?.user;
    let language = initialState?.language;

    if (!user) {
      const localLanguage = getLocalLanguage();

      if (localLanguage) {
        language = {
          ...language,
          language: localLanguage,
        }
      }
    }

    initialState = {
      ...initialState,
      ...ops.initialState,
      dataGrid: {
        ...initialState.dataGrid,
        dataGridByName
      },
      offers: {
        ...initialState.offers,
        ...ops.initialState?.offers,
      },
      language,
    }
  } else {
    history = createMemoryHistory();
  }

  if (ops.cookies) {
    initialState = {
      ...initialState,
      app: {
        ...appInitialState,
        ...initialState.app,
        theme: ops?.cookies?.application_theme === 'dark' ? 'dark' : 'light',
      }
    }
  }

  const middleware = routerMiddleware(history);

  if (module.hot) {
    store = createStore(
      rootReducer,
      initialState,
      composeEnhancers(
        applyMiddleware(thunkMiddleware, myEntityThunk, loggerMiddleware, middleware)
      )
    );

    module.hot.accept('../reducers', () => {
      const nextRootReducer = require('../reducers/index').default;
      store.replaceReducer(nextRootReducer);
    });

  } else {
    store = createStore(
      rootReducer,
      initialState,
      compose(applyMiddleware(thunkMiddleware, myEntityThunk, middleware), f => f)
    );
  }

  return store;
}
